// extracted by mini-css-extract-plugin
export var chip = "_cs-0";
export var filterDropdown = "_cs-5";
export var filterItem = "_cs-6";
export var icon = "_cs-1";
export var removeButton = "_cs-3";
export var removeIcon = "_cs-4";
export var separator = "_cs-2";